import Video from 'Scripts/components/Video'
import Tracker from 'Scripts/components/Tracker'
import Page from 'Scripts/classes/Page'
import Carousel from 'Scripts/animations/Carousel/index'
//Vendor
import Swiper from 'swiper/bundle'

export default class Home extends Page {
  constructor() {
    super('home', {
      container: '.home',
      elements: {
        homeSlider: '.homeslider',
        groupVideo: '.group__video',
        clientWrapper: '.client__wrapper',
        metierWrapper: '.metiers__wrapper',
        metierSlider: '.metiers__slider',
        popupWrapper: '#popup__wrapper',
        popupOverlay: '.popup__overlay',
        popupButton: '.popup__button',
      },
    })

    //Methods
    this.initHomeSlider()
    this.initVideo()
    this.initALaUneSlider()
    this.elements.popupWrapper && this.popupinit()

    this.elements.metierSlider &&
      new Carousel({
        wrapper: '.metiers__wrapper',
        carouselSelector: '.metiers__slider',
        mediasSelector: '.metiers__item',
      })

    this.elements.clientWrapper &&
      new Carousel({
        wrapper: '.client__wrapper',
        carouselSelector: '.client__slider',
        mediasSelector: '.client__item',
        loop: false,
        autoplay: false,
      })

    this.initRealisation()
  }

  initRealisation() {
    new Tracker()
  }

  initHomeSlider() {
    const progressBarElm = document.querySelector('.slider__timer')

    this.homeSlider = new Swiper('.slider', {
      slidesPerView: '1',
      speed: 1200,
      grabCursor: true,
      loop: true,
      // touchEventsTarget : 'container',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.slider__pagination',
        bulletActiveClass: 'isActive',
        bulletClass: 'slider__pagination_bullet',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<div class="' +
            className +
            '"><span><span class="position">0' +
            (index + 1) +
            '</span></span></div>'
          )
        },
      },
      on: {
        init: (slide) => {
          // console.log(slide)
          if (slide.slides.length == 1) {
            // console.log(slide.pagination.el.querySelector('.position'))
            progressBarElm.style.opacity = '0'
            slide.pagination.el.querySelector('.position').style.opacity = '0'
          }
          progressBarElm.classList.remove('animated')
          progressBarElm.classList.add('animated')
          if (this.deviceType !== 'mobile') {
            const sliderTextHeight = slide.slides[slide.activeIndex].lastElementChild.clientHeight
            const sliderPaginationHeight = slide.pagination.el.clientHeight
            slide.pagination.el.style[this.transformPrefix] = `translateY(${
              (sliderPaginationHeight - sliderTextHeight) / 2
            }px)`
          }
        },
        slideChangeTransitionStart: () => {
          progressBarElm.classList.remove('animated')
        },
        slideChangeTransitionEnd: () => {
          progressBarElm.classList.add('animated')
        },
      },
    })
  }

  initVideo() {
    new Video({ selector: '.group__video video', playBtn: '.group__video_link' })
  }

  initALaUneSlider() {
    this.alauneTextSlider = new Swiper('.alaune__for', {
      slidesPerView: 1,
      centeredSlides: false,
      effect: 'fade',
      loop: true,
      allowTouchMove: false,
    })

    this.alauneImgSlider = new Swiper('.alaune__nav', {
      slidesPerView: 'auto',
      centeredSlides: false,
      grabCursor: true,
      loop: true,
      speed: 800,
      initialSlide: 0,
      slideToClickedSlide: true,
      spaceBetween: window.innerWidth > 768 ? window.innerWidth / 2 : window.innerWidth - 50 - 195,
      navigation: {
        nextEl: '.alaune__navigation_next',
      },
      pagination: {
        el: '.alaune__pagination',
        type: 'fraction',
      },
      thumbs: {
        swiper: this.alauneTextSlider,
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
        },
      },
    })
  }

  popupinit() {
    this.elements.popupOverlay?.addEventListener('click', this.closePopup.bind(this))
    this.popupButton?.addEventListener('click', this.closePopup.bind(this))
    // Show the popup after a delay
    setTimeout(() => {
      this.elements.popupWrapper?.classList.add('popup--visible')
    }, 5000)
  }

  closePopup() {
    this.elements.popupWrapper?.classList.remove('popup--visible')
  }

  /**
   * Animations.
   */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }
}
